import * as React from 'react';
import styled from 'styled-components';
import {P2, SectionTitle, Subtitle} from "../Kit/Kit";
import {HeroContainer} from "../Container/Container";
import aboutBG from '../../assets/img/aboutBG.jpg';

const Container = HeroContainer.extend`
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
`;

const AboutContainer = styled.div`
  position: relative;
  background: #fff;
  padding: 50px 16px 32px;
  width: 100%;
  margin: 100px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  @media(min-width: 768px){
      padding: 60px 32px;
  }
   @media(min-width: 992px){
    padding: 100px 80px 64px;
    width: 1100px;
  }
   @media(min-width: 1200px){
  
  }
`;

const AboutTitle = SectionTitle.extend`
  z-index: 1;
  margin-bottom: 16px;
  
  @media(min-width: 768px){
    margin-bottom: 32px;
  }

  @media(min-width: 992px) {
    font-size: 50px;
    margin-bottom: 40px;
  }
  
  @media(min-width: 1200px) {
    margin-bottom: 50px;
  }
`;

const AboutBG = styled.img`
  position: absolute;
  top: 10%;
  z-index: 0;
`;

const AboutSubtitle = Subtitle.extend`
  margin-bottom: 12px;
  text-align: center;
  
  @media(min-width: 768px) {
    margin-bottom: 28px;
  }

 @media(min-width: 992px) {
    margin-bottom: 36px;
  }
  
   @media(min-width: 1200px) {
    margin-bottom: 46px;
  }

`;

const Header = (props) => {
    const {header, subheader, paragraph, background_image: {source_url, alt_text}} = props.data;
    return (
      <Container
        style={{background: `url(${source_url}) no-repeat bottom`}}
      >
          <AboutContainer>
              <AboutBG src={aboutBG}/>
              <AboutTitle
                dangerouslySetInnerHTML={{__html: header}}
              />
              <AboutSubtitle
                dangerouslySetInnerHTML={{__html: subheader}}
              />
              <P2
                dangerouslySetInnerHTML={{__html: paragraph}}
              />
          </AboutContainer>

      </Container>
    );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/GetToKnow/Header.js